import Image from "@components/Image";
import cx from "classnames";
import styles from "./Banner.module.scss";
import _ from "lodash";
const View = ({ src, title, alt, image, className }: any) => {
  return (
    <div className={cx("slide-item animated", styles.slideItem, className)}>
      <div className={styles.slideTitle}>{title}</div>
      <Image
        speed="-1.5"
        wrapperProps={{ className: styles.wrapperImage }}
        className={styles.image}
        src={src ?? _.get(image, "src", "")}
        alt={alt ?? _.get(image, "alt", "")}
        layout="fill"
        objectFit="cover"
        scale={1.02}
      />
    </div>
  );
};
export default View;
